import React from 'react'
import EasingMotion from './easing-motion'
import uid from 'uid'
import { spring } from 'react-motion'
import { SPRING } from '../constants'
import { guardProps } from './validate'

class EasingLine extends React.PureComponent {
  static defaultProps = {
    arrow: false,
    className: 'easing-line',
    strokeDasharray: null,
    strokeWidth: null,
    stroke: 'inherit',
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 0
  }

  contextTypes: {
    animate: boolean
  }

  constructor(props, context) {
    super(props, context)

    this.arrowId = 'arrow-' + uid()
  }

  renderLine({ x1, x2, y1, y2 }) {
    let marker = this.props.arrow ? `url(#${this.arrowId})` : null

    return <line x1={x1} x2={x2} y1={y1} y2={y2} markerEnd={marker} />
  }

  renderArrow() {
    const { arrow } = this.props

    if (arrow === false) {
      return null
    }

    return (
      <marker
        id={this.arrowId}
        viewBox="0 0 10 10"
        refX="12"
        refY="5"
        markerWidth="6"
        markerHeight="6"
        orient="auto"
      >
        <path d="M 0 0 L 10 5 L 0 10 z" stroke="none" />
      </marker>
    )
  }

  render() {
    const { x1, x2, y1, y2, arrow, arrowOffsetY, ...props } = this.props

    if (guardProps(this, 'x1', 'x2', 'y1', 'y2')) {
      return null
    }

    const style = {
      x1: spring(x1, SPRING),
      x2: spring(x2, SPRING),
      y1: spring(y1, SPRING),
      y2: spring(y2, SPRING)
    }

    return (
      <g {...props}>
        {this.renderArrow()}
        <EasingMotion style={style} static={this.props}>
          {style => this.renderLine(style)}
        </EasingMotion>
      </g>
    )
  }
}

export default EasingLine



// WEBPACK FOOTER //
// /home/runner/work/web-interactive/web-interactive/lib/components/charts/shapes/easing-line.js